/*
    Custom JavaScript for Spotessence Theme
*/

// ===== FUNCIONALIDAD DE COMUNAS PARA EL CARRITO =====
console.log('🚀 Cargando funcionalidad de comunas en custom.js');

// Función para normalizar caracteres especiales (tildes y ñ)
function normalizeText(text) {
  if (!text) return text;

  return text
    .normalize('NFD') // Descompone los caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Elimina los diacríticos (tildes)
    .replace(/ñ/g, 'n') // Reemplaza ñ minúscula
    .replace(/Ñ/g, 'N'); // Reemplaza Ñ mayúscula
}

// Datos de regiones y comunas
window.comunasData = {
  cities: {
    "AP": "Arica y Parinacota",
    "TA": "Tarapacá",
    "AN": "Antofagasta",
    "AT": "Atacama",
    "CO": "Coquimbo",
    "VS": "Valparaíso",
    "RM": "Región Metropolitana",
    "LI": "O'Higgins",
    "ML": "Maule",
    "NB": "Ñuble",
    "BI": "Biobio",
    "AR": "Araucanía",
    "LR": "Los Ríos",
    "LL": "Los Lagos",
    "AI": "Aysén",
    "MA": "Magallanes"
  },
  times: {
    "AP": "3 a 7 días hábiles aprox",
    "TA": "3 a 7 días hábiles aprox",
    "AN": "3 a 7 días hábiles aprox",
    "AT": "3 a 7 días hábiles aprox",
    "CO": "3 a 5 días hábiles aprox",
    "VS": "2 a 5 días hábiles aprox",
    "RM": "2 a 5 días hábiles aprox",
    "LI": "3 a 5 días hábiles aprox",
    "ML": "3 a 5 días hábiles aprox",
    "NB": "3 a 5 días hábiles aprox",
    "BI": "3 a 5 días hábiles aprox",
    "AR": "3 a 5 días hábiles aprox",
    "LR": "3 a 5 días hábiles aprox",
    "LL": "3 a 5 días hábiles aprox",
    "AI": "3 a 7 días hábiles",
    "MA": "hasta 10 días hábiles"
  },
  towns: {
    "AN": ["Antofagasta", "Calama", "Maria Elena", "Mejillones", "Ollagüe", "San Pedro de Atacama", "Sierra Gorda", "Taltal", "Tocopilla"],
    "AR": ["Angol", "Carahue", "Cholchol", "Collipulli", "Cunco", "Curacautin", "Curarrehue", "Ercilla", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Lonquimay", "Los Sauces", "Lumaco", "Melipeuco", "Nueva Imperial", "Padre las Casas", "Perquenco", "Pitrufquen", "Pucon", "Puren", "Renaico", "Saavedra", "Temuco", "Teodoro Schmidt", "Tolten", "Traiguen", "Victoria", "Vilcun", "Villarrica"],
    "AP": ["Arica", "Camarones", "General Lagos", "Putre"],
    "AT": ["Alto del Carmen", "Caldera", "Chañaral", "Copiapo", "Diego de Almagro", "Freirina", "Huasco", "Tierra Amarilla", "Vallenar"],
    "AI": ["Aisen", "Chile Chico", "Cisnes", "Cochrane", "Coihaique", "Guaitecas", "Lago Verde", "O'Higgins", "Rio Ibañez", "Tortel"],
    "BI": ["Alto Biobio", "Antuco", "Arauco", "Cabrero", "Cañete", "Chiguayante", "Concepcion", "Contulmo", "Coronel", "Curanilahue", "Florida", "Hualpen", "Hualqui", "Laja", "Lebu", "Los Alamos", "Los Angeles", "Lota", "Mulchen", "Nacimiento", "Negrete", "Penco", "Quilaco", "Quilleco", "San Pedro de la Paz", "San Rosendo", "Santa Barbara", "Santa Juana", "Talcahuano", "Tirua", "Tome", "Tucapel", "Yumbel"],
    "CO": ["Andacollo", "Canela", "Combarbala", "Coquimbo", "Illapel", "La Higuera", "La Serena", "Los Vilos", "Monte Patria", "Ovalle", "Paihuano", "Punitaqui", "Rio Hurtado", "Salamanca", "Vicuña"],
    "LL": ["Ancud", "Calbuco", "Castro", "Chaiten", "Chonchi", "Cochamo", "Curaco de Velez", "Dalcahue", "Fresia", "Frutillar", "Futaleufu", "Hualaihue", "Llanquihue", "Los Muermos", "Maullin", "Osorno", "Palena", "Puerto Montt", "Puerto Octay", "Puerto Varas", "Puqueldon", "Purranque", "Puyehue", "Queilen", "Quellon", "Quemchi", "Quinchao", "Rio Negro", "San Juan de la Costa", "San Pablo"],
    "LR": ["Corral", "Futrono", "La Union", "Lago Ranco", "Lanco", "Los Lagos", "Mariquina", "Mafil", "Paillaco", "Panguipulli", "Rio Bueno", "Valdivia"],
    "MA": ["Antartica", "Cabo de Hornos (Ex Navarino)", "Laguna Blanca", "Natales", "Porvenir", "Primavera", "Punta Arenas", "Rio Verde", "San Gregorio", "Timaukel", "Torres del Paine"],
    "ML": ["Cauquenes", "Chanco", "Colbun", "Constitucion", "Curepto", "Curico", "Empedrado", "Hualañe", "Licanten", "Linares", "Longavi", "Maule", "Molina", "Parral", "Pelarco", "Pelluhue", "Pencahue", "Rauco", "Retiro", "Romeral", "Rio Claro", "Sagrada Familia", "San Clemente", "San Javier", "San Rafael", "Talca", "Teno", "Vichuquen", "Villa Alegre", "Yerbas Buenas"],
    "NB": ["Bulnes", "Chillan", "Chillan Viejo", "Cobquecura", "Coelemu", "Coihueco", "El Carmen", "Ninhue", "Pemuco", "Pinto", "Portezuelo", "Quillon", "Quirihue", "Ranquil", "San Carlos", "San Fabian", "San Ignacio", "San Nicolas", "Treguaco", "Yungay", "Ñiquen"],
    "LI": ["Chimbarongo", "Chepica", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "La Estrella", "Las Cabras", "Litueche", "Lolol", "Machali", "Malloa", "Marchihue", "Mostazal", "Nancagua", "Navidad", "Olivar", "Palmilla", "Paredones", "Peralillo", "Peumo", "Pichidegua", "Pichilemu", "Placilla", "Pumanque", "Quinta de Tilcoco", "Rancagua", "Rengo", "Requinoa", "San Fernando", "San Vicente", "Santa Cruz"],
    "RM": ["Alhue", "Buin", "Calera de Tango", "Cerrillos", "Cerro Navia", "Colina", "Conchali", "Curacavi", "El Bosque", "El Monte", "Estacion Central", "Huechuraba", "Independencia", "Isla de Maipo", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipu", "Maria Pinto", "Melipilla", "Padre Hurtado", "Paine", "Pedro Aguirre Cerda", "Peñaflor", "Peñalolen", "Pirque", "Providencia", "Pudahuel", "Puente Alto", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Bernardo", "San Joaquin", "San Jose de Maipo", "San Miguel", "San Pedro", "San Ramon", "Santiago", "Talagante", "Tiltil", "Vitacura", "Ñuñoa"],
    "TA": ["Alto Hospicio", "Camiña", "Colchane", "Huara", "Iquique", "Pica", "Pozo Almonte"],
    "VS": ["Algarrobo", "Cabildo", "Calera", "Calle Larga", "Cartagena", "Casablanca", "Catemu", "Concon", "El Quisco", "El Tabo", "Hijuelas", "Isla de Pascua", "Juan Fernandez", "La Cruz", "La Ligua", "Limache", "Llaillay", "Los Andes", "Nogales", "Olmue", "Panquehue", "Papudo", "Petorca", "Puchuncavi", "Putaendo", "Quillota", "Quilpue", "Quintero", "Rinconada", "San Antonio", "San Esteban", "San Felipe", "Santa Maria", "Santo Domingo", "Valparaiso", "Villa Alemana", "Viña del Mar", "Zapallar"]
  }
};

// Función para inicializar los selectores de comunas
window.initComunasSelectors = function() {
  console.log('🚀 Iniciando selectores de comunas desde custom.js');

  const citySelect = document.getElementById('select-city');
  const townSelect = document.getElementById('select-town');

  if (!citySelect || !townSelect) {
    console.log('❌ Selectores no encontrados');
    return;
  }

  console.log('✅ Selectores encontrados, configurando...');

  // Cargar regiones
  loadRegions();

  // Event listeners usando delegación
  document.addEventListener('change', handleSelectChange);
};

function loadRegions() {
  const citySelect = document.getElementById('select-city');
  if (!citySelect) return;

  citySelect.innerHTML = '<option value="">Selecciona tu Región</option>';

  for (let code in window.comunasData.cities) {
    const option = document.createElement('option');
    option.value = code;
    option.textContent = window.comunasData.cities[code];
    citySelect.appendChild(option);
  }

  console.log('📍 Regiones cargadas:', Object.keys(window.comunasData.cities).length);
}

function loadTowns(regionCode) {
  const townSelect = document.getElementById('select-town');
  if (!townSelect) return;

  townSelect.innerHTML = '<option value="">Selecciona tu Comuna</option>';

  if (regionCode && window.comunasData.towns[regionCode]) {
    window.comunasData.towns[regionCode].forEach(town => {
      const option = document.createElement('option');
      option.value = town;
      option.textContent = town;
      townSelect.appendChild(option);
    });
    console.log('🏘️ Comunas cargadas:', window.comunasData.towns[regionCode].length);
  }
}

function handleSelectChange(e) {
  if (e.target.id === 'select-city') {
    console.log('🌍 Región seleccionada:', e.target.value);
    const regionCode = e.target.value;

    if (regionCode) {
      loadTowns(regionCode);
    }
  } else if (e.target.id === 'select-town') {
    console.log('🏘️ Comuna seleccionada:', e.target.value);
    const selectedTown = e.target.value;
    const citySelect = document.getElementById('select-city');
    const selectedRegion = citySelect ? citySelect.value : '';

    if (selectedTown && selectedRegion) {
      // Actualizar formulario
      updateCheckoutForm(selectedRegion, selectedTown);

      // Actualizar estilos
      document.querySelectorAll('.comunas select').forEach(select => {
        select.classList.remove('rojo');
        select.classList.add('verde');
      });

      const alertElement = document.querySelector('.comunas .alert');
      if (alertElement) {
        alertElement.style.display = 'none';
      }
    }
  }
}

function updateCheckoutForm(selectedRegion, selectedTown) {
  if (!selectedRegion || !selectedTown) return;

  // Normalizar los datos antes de enviarlos
  const normalizedProvince = normalizeText(window.comunasData.cities[selectedRegion]);
  const normalizedCity = normalizeText(selectedTown);

  const shippingAddress = {
    country: 'CL',
    province: normalizedProvince,
    city: normalizedCity,
    zip: '0000000'
  };

  // Actualizar carrito con datos normalizados
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        region: normalizedProvince,
        ciudad: normalizedCity
      }
    })
  })
  .then(response => response.json())
  .then(() => {
    // Buscar formulario tanto en la página del carrito como en el offcanvas
    const offcanvasForm = document.querySelector('#offcanvas-cart #cart-form');
    const pageForm = document.querySelector('#cart #cart-form');
    const form = offcanvasForm || pageForm;

    if (form) {
      console.log('📋 Formulario encontrado:', form.id || 'sin ID');

      // Limpiar campos existentes
      const existingFields = form.querySelectorAll('input[name^="checkout[shipping_address]"]');
      existingFields.forEach(field => field.remove());

      // Agregar nuevos campos con datos normalizados
      Object.entries(shippingAddress).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `checkout[shipping_address][${key}]`;
        input.value = value;
        form.insertBefore(input, form.firstChild);
      });

      // Crear URL con parámetros normalizados
      const params = new URLSearchParams({
        'checkout[shipping_address][country]': 'CL',
        'checkout[shipping_address][province]': normalizedProvince,
        'checkout[shipping_address][city]': normalizedCity,
        'checkout[shipping_address][zip]': '0000000'
      });

      // Actualizar la acción del formulario para incluir los parámetros
      if (offcanvasForm) {
        form.action = `/checkout?${params.toString()}`;
      } else if (pageForm) {
        // Para la página del carrito, actualizar el botón de checkout
        const checkoutBtn = form.querySelector('button[name="checkout"]');
        if (checkoutBtn) {
          checkoutBtn.onclick = function(e) {
            e.preventDefault();
            window.location.href = `/checkout?${params.toString()}`;
          };
        }
      }

      console.log('✅ Formulario actualizado con región normalizada:', normalizedProvince, 'y ciudad normalizada:', normalizedCity);
    } else {
      console.warn('⚠️ No se encontró formulario del carrito');
    }
  })
  .catch(error => console.error('❌ Error actualizando carrito:', error));
}

// Escuchar evento de actualización del carrito
window.addEventListener('updated.ecomify.cart', function() {
  console.log('🔄 Carrito actualizado, reinicializando selectores...');
  setTimeout(() => {
    window.initComunasSelectors();
  }, 200);
});

// Inicializar al cargar la página
document.addEventListener('DOMContentLoaded', function() {
  console.log('📄 DOM listo, inicializando comunas...');
  window.initComunasSelectors();
});

// ===== FIN FUNCIONALIDAD DE COMUNAS =====


// ===== SCROLL REVEAL FADE-IN (Madison-style) =====
// Aplica .is-revealed cuando el elemento entra al viewport.
(function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var REVEAL_SELECTOR = [
        'section[id]',
        '.featured-products',
        '.product-item',
        '.splide__slide',
        '.cyber-day-grid-card',
        '.cards-promo',
        '.collection-hero',
        '.aroma-finder',
        '.shopify-section > .container',
        '.shopify-section > .container-fluid',
        '[data-reveal]'
    ].join(',');

    function initReveal() {
        var els = document.querySelectorAll(REVEAL_SELECTOR);
        if (!els.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-revealed');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.05
        });

        els.forEach(function (el, i) {
            if (el.classList.contains('is-revealed')) return;
            // El sticky ATC tiene su propia animación de entrada/salida ligada al scroll.
            if (el.id === 'sticky-atc') return;
            el.classList.add('reveal-on-scroll');
            // Delay incremental dentro de la misma fila visible (max 4 elementos)
            var delay = Math.min(i % 4, 4) * 80;
            el.style.setProperty('--reveal-delay', delay + 'ms');
            observer.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initReveal);
    } else {
        initReveal();
    }

    // Re-init cuando Shopify renderiza secciones nuevas
    document.addEventListener('shopify:section:load', initReveal);
})();
// ===== FIN SCROLL REVEAL =====

// ===== STICKY HEADER OFFSET (collection filter bar mobile)
// El header-group de Spot Essence es position:sticky top:0. Para que el filter
// bar mobile (#collection-utilities) se pegue JUSTO DEBAJO del header sin gap,
// medimos la altura del header sticky y la exponemos como CSS variable.
(function () {
    var headerSticky = document.querySelector('.shopify-section-group-header-group.sticky-top, [data-header-sticky]');
    if (!headerSticky) return;

    function setOffset() {
        var navbarIsHidden = headerSticky.classList.contains('is-hidden-on-scroll');
        var h = navbarIsHidden ? 0 : (headerSticky.offsetHeight || 0);
        document.documentElement.style.setProperty('--sticky-header-h', h + 'px');
    }

    setOffset();
    new MutationObserver(setOffset).observe(headerSticky, {
        attributes: true,
        attributeFilter: ['class']
    });
    window.addEventListener('resize', setOffset);
    window.addEventListener('load', setOffset);
    document.addEventListener('shopify:section:load', setOffset);
    document.addEventListener('shopify:section:unload', setOffset);
})();
// ===== FIN STICKY HEADER OFFSET =====

// ===== PRODUCT ACCORDION ANIMATION =====
// Delegated so it survives the AJAX product swaps used by aroma/color selectors.
(function () {
    if (window.spotAccordionAnimationBound) return;
    window.spotAccordionAnimationBound = true;

    var duration = 450;

    document.addEventListener('click', function (event) {
        if (!event.target || !event.target.closest) return;

        var summary = event.target.closest('[data-spot-accordion-summary]');
        if (!summary) return;

        var details = summary.closest('[data-spot-accordion-item]');
        var panel = details && details.querySelector('.spot-accordion-panel');
        if (!details || !panel) return;

        event.preventDefault();
        if (details.dataset.spotAccordionAnimating === 'true') return;

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (details.open) {
            details.classList.add('is-closing');
            if (reduceMotion) {
                details.open = false;
                details.style.removeProperty('--spot-acc-panel-h');
                details.classList.remove('is-closing');
                return;
            }

            details.dataset.spotAccordionAnimating = 'true';
            details.style.setProperty('--spot-acc-panel-h', panel.scrollHeight + 'px');
            panel.getBoundingClientRect();
            details.style.setProperty('--spot-acc-panel-h', '0px');
            window.setTimeout(function () {
                details.open = false;
                details.style.removeProperty('--spot-acc-panel-h');
                details.classList.remove('is-closing');
                delete details.dataset.spotAccordionAnimating;
            }, duration);
        } else {
            details.classList.remove('is-closing');
            details.style.setProperty('--spot-acc-panel-h', '0px');
            details.open = true;

            if (reduceMotion) {
                details.style.setProperty('--spot-acc-panel-h', panel.scrollHeight + 'px');
                return;
            }

            details.dataset.spotAccordionAnimating = 'true';
            panel.getBoundingClientRect();
            details.style.setProperty('--spot-acc-panel-h', panel.scrollHeight + 'px');
            window.setTimeout(function () {
                delete details.dataset.spotAccordionAnimating;
            }, duration);
        }
    });

    window.addEventListener('resize', function () {
        document.querySelectorAll('[data-spot-accordion-item][open]').forEach(function (details) {
            if (details.dataset.spotAccordionAnimating === 'true') return;
            var panel = details.querySelector('.spot-accordion-panel');
            if (panel) details.style.setProperty('--spot-acc-panel-h', panel.scrollHeight + 'px');
        });
    });
})();
// ===== FIN PRODUCT ACCORDION ANIMATION =====

// ===== LOOX REVIEWS COLLAPSE + "VER MÁS RESEÑAS" =====
// El widget de Loox (iframe) renderiza todas las reviews stacked sin
// pagination. En productos populares genera 2000+px de scroll. Aquí
// limitamos altura a 900px con fade overlay y agregamos un botón toggle.
// Cross-origin: NO tocamos el contenido del iframe, solo el container.
// Solo colapsamos cuando hay suficientes reviews y el espacio ahorrado
// es significativo para la pantalla actual.
(function () {
    // Altura visible (900px) se setea en CSS via .spot-loox-collapsed.
    var COLLAPSED_HEIGHT = 900;
    var MIN_HIDDEN_HEIGHT = 300;
    var MIN_REVIEWS_TO_COLLAPSE = 8;
    var POLL_INTERVAL = 600;
    var STABLE_REQUIRED = 3;

    function getReviewCount() {
        var source = document.querySelector('[data-spot-review-count]');
        if (!source) return 0;

        return parseInt(source.dataset.spotReviewCount, 10) || 0;
    }

    function shouldInstall(containerHeight) {
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var minimumUsefulHeight = Math.max(
            COLLAPSED_HEIGHT + MIN_HIDDEN_HEIGHT,
            viewportHeight + MIN_HIDDEN_HEIGHT
        );

        return getReviewCount() >= MIN_REVIEWS_TO_COLLAPSE && containerHeight >= minimumUsefulHeight;
    }

    function install(container) {
        if (container.dataset.spotLooxInit === '1') return;
        container.dataset.spotLooxInit = '1';

        var fade = document.createElement('div');
        fade.className = 'spot-loox-fade';
        container.appendChild(fade);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'spot-loox-toggle';
        btn.textContent = 'Ver más reseñas';
        btn.setAttribute('aria-expanded', 'false');
        container.insertAdjacentElement('afterend', btn);

        container.classList.add('spot-loox-collapsed');

        btn.addEventListener('click', function () {
            var isCollapsed = container.classList.contains('spot-loox-collapsed');
            var iframe = document.getElementById('looxReviewsFrame');
            var fullHeight = iframe ? iframe.getBoundingClientRect().height + 40 : 5000;

            if (isCollapsed) {
                // Expanding: setear inline max-height al height final para que
                // CSS pueda animar entre 900px → fullHeight smoothly.
                container.style.maxHeight = fullHeight + 'px';
                container.classList.remove('spot-loox-collapsed');
                btn.setAttribute('aria-expanded', 'true');
                btn.textContent = 'Ver menos reseñas';

                // Después de la transition, liberamos el max-height inline para
                // que si el iframe crece después (lazy load de imágenes), el
                // container se ajuste.
                setTimeout(function () {
                    container.style.maxHeight = 'none';
                }, 750);
            } else {
                // Collapsing: primero seteamos el max-height actual concreto
                // (para que la transition tenga from-value), luego agregamos
                // la clase que setea 900px.
                container.style.maxHeight = container.getBoundingClientRect().height + 'px';
                // Force reflow para que el browser aplique el valor antes del
                // siguiente cambio.
                void container.offsetHeight;
                container.style.maxHeight = '';
                container.classList.add('spot-loox-collapsed');
                btn.setAttribute('aria-expanded', 'false');
                btn.textContent = 'Ver más reseñas';
                container.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }

    function waitForStableHeight() {
        var container = document.getElementById('looxReviews');
        if (!container) return;

        var lastHeight = 0;
        var stableCount = 0;

        var iv = setInterval(function () {
            var h = container.getBoundingClientRect().height;
            if (h === lastHeight && h > 0) {
                stableCount++;
                if (stableCount >= STABLE_REQUIRED) {
                    clearInterval(iv);
                    if (shouldInstall(h)) install(container);
                }
            } else {
                stableCount = 0;
                lastHeight = h;
            }
        }, POLL_INTERVAL);

        setTimeout(function () { clearInterval(iv); }, 20000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForStableHeight);
    } else {
        waitForStableHeight();
    }
})();
// ===== FIN LOOX REVIEWS COLLAPSE =====
